import Bowser from "bowser";
import Splide from "@splidejs/splide";
// import MicroModal from "micromodal";
import * as DOMPurify from "dompurify";
import Typewriter from "typewriter-effect/dist/core";
import "waypoints/lib/noframework.waypoints.min";
import { CountUp } from "countup.js/dist/countUp.min.js";

// MicroModal
// MicroModal.init({
//   onShow: function() {
//     document.querySelector("html").classList.add("locked");
//   },
//   onClose: function() {
//     document.querySelector("html").classList.remove("locked");
//   }
// });

jQuery(document).ready(function($) {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
    $("body").addClass("touch");
  }

  // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  const userBrowser = Bowser.getParser(window.navigator.userAgent);
  const browser = userBrowser.getBrowser();

  if (browser.name === "Internet Explorer" && browser.version == "11.0") {
    $("body").addClass("ie-11");
  } else if (browser.name === "Safari") {
    $("body").addClass("safari");
  }

  // Menu functions
  function toggleMenu(icon, menu) {
    $("html").toggleClass("locked");
    $("body").toggleClass("locked masked");

    icon.toggleClass("active");
    menu.slideToggle();
  }

  function closeMenu(icon, menu) {
    if( menu.css("display") == "block" ) {
      $("html").removeClass("locked");
      $("body").removeClass("locked masked");
    }

    icon.removeClass("active");
    menu.slideUp();
  }

  // Main menu function
  $(".menu-icon").on("click", function() {
    toggleMenu($(this), $(".nav--mobile"));
  });

  // Close menu on desktop
  $(window).on("resize", function() {
    if( $(window).width() > 1024 ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on outside click
  $(document).on("click", function(e) {
    if( !$(e.target).closest(".site-header").length ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on ESC key 
  $(document).on("keyup", function(e) {
    if( e.which == 27) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Mobile menu sub-menu toggle
  $(".nav--mobile .menu-item-has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this).siblings(".sub-menu").slideToggle();
    $(this).toggleClass("active");
  });

  // Typewriter text 
  if( $(".typewriter").length ) {
    $(".typewriter").each(function() {
      let phrases = $(this).attr("data-phrases").split(", "),
        count = phrases.length,
        typewriter;
      
      // Only loop if more than 1 phrase
      if( count > 1 ) {

        typewriter = new Typewriter(this, {
          loop: true,
          delay: 50,
          autoStart: true,
          strings: phrases,
        });

        typewriter.start();

      } else {

        typewriter = new Typewriter(this, {
          delay: 50,
        }).typeString(phrases[0]).start();
      }

    });
  }

  // Form Label Animation
  $(".gform_wrapper form .animated").find("input, select, textarea").on("focusin", function() {
  	$(this).parents(".animated").children("label").addClass("active-position active-weight active-color");

  	// Off focus
  	$(".gform_wrapper form .animated").find("input, select, textarea").on("focusout", function() {
  		if( $(this).val() !== "" ) { // Remove active weight and keep raised position if input has content
  			$(this).parents(".animated").children("label").removeClass("active-weight");
  		} else { // Else remove both weight and raised position
  			$(this).parents(".animated").children("label").removeClass("active-position active-weight active-color");
  		}
  	});
  });

  // Logo slider section (SplideJS)
  if( $(".logo-slider-section__slider").length ) {
    $(".logo-slider-section__slider").each(function() {
      new Splide(this, {
        type: "loop",
        perPage: 4,
        perMove: 1,
        pagination: false,
        breakpoints: {
          1024: {
            perPage: 3
          },
          767: {
            perPage: 2
          },
          500: {
            perPage: 1
          }
        }
      }).mount();
    });
  }

  // Stats row animation 
  if( $(".stats-row").length ) {
    $(".stats-row__stat").each(function() {
      let stat = $(this).find(".stats-row__number")[0],
        number = $(this).find(".stats-row__number").attr("data-number");

      let countUp = new CountUp(stat, number);

      // eslint-disable-next-line
      new Waypoint({
        element: $(this).parents(".stats-row")[0],
        handler: function() {
          if (!countUp.error) {
            countUp.start();
          } else {
            // eslint-disable-next-line
            console.error(countUp.error);
          }
        },
        offset: 500
      });
    });
  }

  // Accordions section 
  $(".accordion__header").on("click", function() {
    // Close other accordions
    $(this).parents(".accordions-section").find(".accordion__header").not(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    $(this).parents(".accordions-section").find(".accordion__header").not(this).siblings(".accordion__content").slideUp();

    // Toggle this one
    if( $(this).find("i").hasClass("fa-plus") ) {
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
    } else {
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    }
    
    $(this).siblings(".accordion__content").slideToggle();
  });

  // Smooth anchor link scrolling 
  $("a[href*=\\#]").on("click", function (e) {
    let slug = this.href.split("#")[1].replace("#", "");

    // Only if no matching modal
    if( !$(".modal#modal-" + slug).length && $(".anchor#" + slug).length ) {
      e.preventDefault();
      if(this.pathname === window.location.pathname) {
        // Store hash
        let hash = this.hash;
  
        $("html, body").animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
  
          window.location.hash = hash;
        });
      }
    }
  });

  // Trigger matching modal (if there) when hash 
  // if( window.location.hash) {
  //   let hash = window.location.hash.replace("#", "");

  //   if( $(".modal#modal-" + hash).length ) {
  //     MicroModal.show("modal-" + hash);
  //   }
  // }

  // Custom add to cart form with quantity param 
  // Pass variable to query string
  $("form.custom-add-to-cart").on("submit", function(e) {
    e.preventDefault();

    let data = $(this).find(":input"),
      qty = DOMPurify.sanitize(data[0].value),
      product = DOMPurify.sanitize(data[1].value),
      cart = DOMPurify.sanitize(data[2].value);

    let newUrl = `${cart}?add-to-cart=${product}&quantity=${qty}`;

    window.location.href = newUrl;
  });
});
